module.exports = __webpack_public_path__ + "static/media/free-damm-tostada.70d8499a.jpg";